<script setup>

</script>

<template>
  <Transition
    mode="out-in"
    enter-active-class="tw-transition-opacity tw-duration-150 tw-ease-in-out"
    leave-active-class="tw-transition-opacity tw-duration-150 tw-ease-in-out"
    enter-from-class="tw-opacity-0"
    enter-to-class="tw-opacity-100"
    leave-from-class="tw-opacity-100"
    leave-to-class="tw-opacity-0"
  >
    <slot />
  </Transition>
</template>
